import React, { useContext } from 'react';
import PropTypes from 'prop-types';
import locale from '@glu/locale';
import moment from 'moment';
import { withStyles, withTheme } from '@glu/theming';
import { DatePicker } from '@glu/datepicker-react';
import SchedulerContext from './SchedulerContext';

const styles = {
  start: {}
};

const Start = ({
  classes,
  startValue,
  endValue,
  setStartValue,
  error,
  DatePickerProps
}) => {
  const {
    dataQa, htmlId, disabled, dateFormat
  } = useContext(SchedulerContext);
  return (
    <div data-qa={`start-${dataQa || htmlId}`} className={`${classes.start} `}>
      <DatePicker
        htmlId={`${htmlId}-startPicker`}
        singleDatePicker
        disabled={disabled}
        value={[startValue || null, startValue || null]}
        dateMax={moment.isMoment(endValue) ? endValue.format('YYYY-MM-DD') : undefined}
        labelText={locale.get('schedulerReact.startDate')}
        format={dateFormat}
        disableInputAPI
        error={error}
        onChange={(name, values) => setStartValue(values[0])}
        {...DatePickerProps}
      />
    </div>
  );
};

Start.propTypes = {
  /** Classes provided by the theme */
  classes: PropTypes.objectOf(PropTypes.string).isRequired,

  /** Callback to set start value in scheduler */
  setStartValue: PropTypes.func.isRequired,

  /** Start value given */
  startValue: PropTypes.instanceOf(Object),

  /** End value given used to control max start value, either a Date or a number for occurrences */
  endValue: PropTypes.oneOfType([PropTypes.instanceOf(Object), PropTypes.number]),

  /** Passthrough props for datepicker */
  DatePickerProps: PropTypes.objectOf(PropTypes.shape({})),

  /** Error from validation */
  error: PropTypes.string
};

Start.defaultProps = {
  endValue: undefined,
  startValue: undefined,
  DatePickerProps: {},
  error: undefined
};

export const BareStartModule = Start;
export default withTheme(withStyles(styles)(Start));
